import type { ReactNode } from 'react';
import styles from './PhaseIndicator.module.css';
import { Spinner } from './Spinner.js';

/**
 * **`PhaseIndicator`**（§4.3 の 3 / §4.5）。
 *
 * ## 工程名を出す理由は待ち時間の緩和だけではない
 *
 * §4.5:「**再構築ターンの 25〜35 秒は隠せないので説明する**。
 * この製品の価値は『**AI が内部で問題を分解している**』ことなので、
 * **工程の提示は待ち時間の緩和だけでなく製品の説明になる**」。
 *
 * ## 文言は SSE の `label` をそのまま出す（§5.5）
 *
 * **UI 側で言い換えない** — 言い換えると**工程名が 2 か所で定義される**。
 *
 * ## 不可視フェーズには出さない
 *
 * §4.4:「**10〜55 秒（不可視）は何も出さない**。
 * **ここに工程名を出すと隠蔽が壊れる**」。
 * **この部品は出す場所を選ばない**ので、**呼び出し側が守る規約**である。
 * M15 の実測では不可視フェーズは **78〜102 秒**だった。
 */
export interface PhaseIndicatorProps {
  /** **SSE の `label` をそのまま**（UI で言い換えない = §5.5） */
  readonly label: string;
  /**
   * **経過秒**（§4.3）。**再構築ターンで出す。**
   * 省略すると出さない（初回ターンの可視フェーズは約 6 秒なので要らない）。
   */
  readonly elapsedSeconds?: number;
}

export function PhaseIndicator({ label, elapsedSeconds }: PhaseIndicatorProps): ReactNode {
  return (
    <div className={styles['row']}>
      {/* **Spinner は工程名に内包する**（§5.1 の単独使用禁止） */}
      <Spinner label={label} />
      {elapsedSeconds === undefined ? null : (
        <span className={styles['elapsed']}>{elapsedSeconds} 秒</span>
      )}
    </div>
  );
}
